import parseNumber from '@utils/parseNumber';

const getRelativeLink = (user) => {
  let url = `/learner/@${user.username}`;
  if (user.is_educator || user.is_moderator)
    url = user.relative_link || `/@${user.username}`;
  return url;
};
class User {
  constructor(userData) {
    const user = userData.author_details ? userData.author_details : userData;
    this.firstName = user.first_name ? user.first_name.toLocaleString() : '';
    this.lastName = user.last_name ? user.last_name : '';
    this.uid = user.uid;
    this.isFullStoryUser = user.is_full_story_user;
    this.name = `${
      this.firstName.charAt(0).toUpperCase() + this.firstName.slice(1)
    } ${this.lastName.charAt(0).toUpperCase() + this.lastName.slice(1)}`;
    this.thumbnail = user.avatar || null;
    this.description = user.bio || null;
    this.permalink = user.permalink;
    this.relativeLink = getRelativeLink(user);
    this.averageRating = user.avg_rating;

    this.username = user.username.toLowerCase() || null;
    this.referralInfo = user.referral_info;
    this.followersCount = user.followers_count
      ? parseNumber(user.followers_count)
      : null;
    this.followingCount = user.follows_count
      ? parseNumber(user.follows_count)
      : null;
    this.lifetimeViews = user.lifetime_views
      ? parseNumber(user.lifetime_views)
      : null;
    this.starRatings = user.star_ratings
      ? parseNumber(user.star_ratings)
      : null;
    this.isFollowing = user.is_following;
    this.postsCount = user.posts_count ? parseNumber(user.posts_count) : null;
    this.coursesCount = user.courses_count
      ? parseNumber(user.courses_count)
      : null;
    this.isEducator = user.is_educator;
    this.isModerator = user.is_moderator;
    this.isVerifiedEducator = user.is_verified_educator;
    this.isEmailVerified = user.is_email_verified;
    this.isPhoneVerified = user.is_phone_verified;
    this.isProfileFilled = user.is_profile_filled;
    this.dedications = user.dedications;
    this.topicsDisplay = user.topics_display;
    this.stats = user.stats;
    this.phone = user.phone;
    this.email = user.email;
    this.state = user.state;
    this.country = user.country;
    this.language = user.language;
    this.canAddPlusCourse = user.can_add_plus_course;
    this.canAddSpecialClass = user.can_add_special_class;
    this.verifiedEducatorAt = user.verified_educator_at;
    this.liveMinutes = user.live_minutes
      ? Math.round(user.live_minutes / 60)
      : 0;
    this.totalWatchMins = user.total_watch_time
      ? Math.round(user.total_watch_time / 60)
      : 0;
    this.credentials = user.credentials;
    this.languages = user.languages;
    this.becomeEducatorAt = user.become_educator_at;
    this.educatorType = user.educator_type;
    this.knowsAbout = user.knows_about;
    this.dateJoined = user.date_joined;
    this.ogImage = user.og_image || null;
    // #region leaderboard_meta_info
    // # value_props' types
    // 1 - Integer
    // 2 - String
    // exhaustive sample
    // "leaderboard_meta_info": {
    //   "rank": 8,
    //   "value_props": [
    //     {"display_string": "Watch Mins", "value": 20336485, "type": 1},
    //     {"display_string": "Followers", "value": 20336485, "type": 1},
    //     {"display_string": "Highlight", "value": "IIT AIR 3", "type": 2}
    //   ],
    //   // below props are available only in educator api
    //   "goal": {
    //      name: "IIT JEE",
    //      uid: "TMUVD"
    //   }
    //   "topic_group": {
    //      level: 30,
    //      uid: "VKKVN"
    //   }
    // }
    // #endregion leaderboard_meta_info
    this.leaderboardMetaInfo = user.leaderboard_meta_info || null;
  }
}

const getEntityData = (data) => {
  const user = new User(data);
  return user;
};

export const isLegendEducator = (data = {}) => {
  return data.uid === 'WO7LDJ3Y2Z' || data.educatorType === 4;
};

export default { User, getEntityData, isLegendEducator };
